module.exports = __webpack_public_path__ + "static/media/menu3.fc9eedc6.jfif";